import { Switch as V2Switch } from '@foresightdata/web-common-components';
import { Switch as MuiSwitch, SwitchProps as MuiSwitchProps } from '@mui/material';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { MaggieFeatureFlags } from '../../util/feature-flags';

/**
 * The app's Switch (FD-6112), the boolean form field. MUI today; web-common's Switch (Base UI)
 * with the flag on. `onChange` gets the new checked state only; `size` is accepted for v1, v2 is
 * MUI's small size. No `sx`.
 */
export interface SwitchProps extends Pick<
  MuiSwitchProps,
  'checked' | 'disabled' | 'size' | 'name' | 'id' | 'title' | 'className' | 'style' | 'aria-label'
> {
  value?: string;
  onChange?: (checked: boolean) => void;
}

export function Switch({ checked, onChange, size, 'aria-label': ariaLabel, ...rest }: SwitchProps) {
  const { useV2Components } = useFlags<MaggieFeatureFlags>();

  if (!useV2Components) {
    return (
      <MuiSwitch
        checked={checked}
        size={size}
        onChange={onChange ? (_event, next) => onChange(next) : undefined}
        // The name belongs on the input, not MUI's root span.
        inputProps={ariaLabel ? { 'aria-label': ariaLabel } : undefined}
        {...rest}
      />
    );
  }

  return (
    <V2Switch
      checked={checked}
      onCheckedChange={onChange ? (next) => onChange(next) : undefined}
      aria-label={ariaLabel}
      {...rest}
    />
  );
}
